import { pdfjs } from 'react-pdf';

// PDF.js worker 설정 - Vite에서는 public 폴더의 worker 파일 사용
if (!pdfjs.GlobalWorkerOptions.workerSrc) {
  pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.mjs';
}

// react-pdf의 pdfjs를 pdfjsLib로도 export하여 일관성 유지
// 이렇게 하면 react-pdf와 동일한 pdfjs 인스턴스를 사용
export { pdfjs };
export const pdfjsLib = pdfjs;

